import React from "react";
import OtpInput from "react-otp-input";
import { useTheme } from "@mui/material";
import { Controller, Control } from "react-hook-form";

interface RHFOtpVerifyProps {
  name: string;
  control?: Control<any>;
  numInputs?: number;
  inputStyle?: React.CSSProperties;
}

export const RHFOtpVerify = ({
  name,
  control,
  numInputs = 4,
  inputStyle,
}: RHFOtpVerifyProps) => {
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <OtpInput
          value={field.value}
          onChange={field.onChange}
          numInputs={numInputs}
          renderInput={(props) => (
            <input
              {...props}
              style={{
                width: 40,
                height: 40,
                margin: "0 8px",
                textAlign: "center",
                fontSize: 18,
                border: "none",
                borderRadius: 8,
                backgroundColor: theme.palette.grey[200],
                outline: "none",
                ...inputStyle,
              }}
            />
          )}
        />
      )}
    />
  );
};
